import { conditionalHooksFactory } from '@atlaskit/platform-feature-flags-react/conditional-hooks-factory';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/useSharedPluginStateSelector';
import type { SyncedBlockPlugin } from '@atlaskit/editor-plugin-synced-block/synced-block-plugin-type';

import { expValEquals } from '@confluence/feature-experiments';

export type EditorPresetAPI = PublicPluginAPI<[SyncedBlockPlugin]> | null | undefined;

export const useSharedSyncBlockState: (_api: EditorPresetAPI) => {
	hasUnsavedBodiedSyncBlockChanges: boolean;
} = conditionalHooksFactory(
	() => expValEquals('platform_synced_block', 'isEnabled', true),
	(api: EditorPresetAPI) => {
		const hasUnsavedBodiedSyncBlockChanges =
			(useSharedPluginStateSelector(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges' as never, {
				disabled: !api,
			}) as boolean | undefined) ?? false;
		return { hasUnsavedBodiedSyncBlockChanges };
	},
	(_api: EditorPresetAPI) => {
		return {
			hasUnsavedBodiedSyncBlockChanges: false,
		};
	},
);
